import { render, staticRenderFns } from "./SsoRealmButton.vue?vue&type=template&id=27c4f3f2&scoped=true&"
import script from "./SsoRealmButton.vue?vue&type=script&lang=js&"
export * from "./SsoRealmButton.vue?vue&type=script&lang=js&"
import style0 from "./SsoRealmButton.vue?vue&type=style&index=0&id=27c4f3f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c4f3f2",
  null
  
)

export default component.exports